import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { GaGeographyModule } from 'gain-lib/geography';
import { GaRegionSelectDialogComponent } from './region-select-dialog/region-select-dialog.component';
import { GaRegionSelectComponent } from 'gain-web/shared-modules/ga-region-select/region-select.component';

@NgModule({
  declarations: [GaRegionSelectDialogComponent, GaRegionSelectComponent],
  imports: [
    CommonModule,
    GaGeographyModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
  ],
  exports: [GaRegionSelectDialogComponent, GaRegionSelectComponent],
})
export class GaRegionSelectModule {}
